var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.visible ? _c('div', {
    staticClass: "absolute right-0 z-50 p-3 mt-2 bg-white border border-gray-200 rounded-lg shadow-lg filter-popup top-full",
    attrs: {
      "data-filter-modal": ""
    }
  }, [_c('div', {
    staticClass: "flex items-center justify-between mb-3"
  }, [_c('h3', {
    staticClass: "text-lg font-normal text-gray-500"
  }, [_vm._v("Filter")]), _c('button', {
    staticClass: "text-gray-400 hover:text-gray-600 focus:outline-none",
    on: {
      "click": _vm.onCancel
    }
  }, [_c('svg', {
    staticClass: "w-5 h-5",
    attrs: {
      "fill": "none",
      "stroke": "currentColor",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      "d": "M6 18L18 6M6 6l12 12"
    }
  })])])]), _c('div', {}, [_c('div', {
    staticClass: "grid grid-cols-1 gap-6"
  }, [_c('div', [_c('FormLabel', {
    attrs: {
      "htmlFor": "renewalStatus"
    }
  }, [_vm._v("Renewal Status")]), _c('SelectRadio', {
    staticClass: "w-full",
    attrs: {
      "options": _vm.statusOptions,
      "defaultText": 'Select Renewal Status'
    },
    model: {
      value: _vm.internalFilters.status,
      callback: function ($$v) {
        _vm.$set(_vm.internalFilters, "status", $$v);
      },
      expression: "internalFilters.status"
    }
  })], 1)]), _c('div', {
    staticClass: "flex justify-start gap-3 mt-6"
  }, [_c('Button', {
    staticClass: "px-6 py-2",
    attrs: {
      "color": "primary",
      "size": "base"
    },
    on: {
      "click": _vm.onApply
    }
  }, [_vm._v(" Filter ")]), _c('Button', {
    staticClass: "px-6 py-2",
    attrs: {
      "color": "alternative",
      "variant": "outlined",
      "size": "base"
    },
    on: {
      "click": _vm.onReset
    }
  }, [_vm._v(" Reset ")])], 1)])]) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }